import Cookies from 'js-cookie';
import ConfigJSON from '../../../config.json';

export default function () {
    jQuery(document).ready(function ($) {
        console.log('lk/account-info from router');
        let me, companies, orders;
        let companiesArray = {};

        let token = Cookies.get('lk-bearer');
        if (!token) {
            window.location = '/my-account/login';
        }

        $.ajax({
            url: LK.api_domain + '/api/v1/me',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'Authorization': token,
            },
            async: true,
            contentType: 'application/json',
            complete: function (jqXHR, status) {
                me = jqXHR.responseJSON;
                if (jqXHR.status != 200) {
                    window.location = '/my-account/login';
                }

                console.log("/api/v1/me:", me);

                // update user info
                $('.lk-sidebar .mai-content .mai-content__title').text(me.data.attributes.name).attr('data-client-id', me.data.id);
                $('.lk-sidebar .mai-content .mai-content__email').text(me.data.attributes.email);

                $('.acc-info-wrapper input[name="name"]').val(me.data.attributes.name);
                $('.acc-info-wrapper input[name="email"]').val(me.data.attributes.email);

                // update design token
                let designToken = btoa(me.data.id + '#' + me.data.id);
                $('.lk-sidebar .design-studio').attr('href', $('.lk-sidebar .design-studio').attr('href') + '?token=' + designToken);
                $('.footer-nav .design-studio').attr('href', $('.lk-sidebar .design-studio').attr('href'));
            }
        });

        $.ajax({
            url: LK.api_domain + '/api/v1/companies?page[page]=1&page[page-size]=10000',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'Authorization': token,
            },
            async: true,
            contentType: 'application/json',
            complete: function (jqXHR, status) {
                companies = jqXHR.responseJSON;
                console.log("/api/v1/companies:", companies);

                $('.acc-info-wrapper .companies-count').text(companies.meta.total);
            }
        });

        $.ajax({
            url: LK.api_domain + '/api/v1/orders?page[page]=1&page[page-size]=10000',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'Authorization': token,
            },
            async: true,
            contentType: 'application/json',
            complete: function (jqXHR, status) {
                $('.lk-body-wrapper').show();
                $('.lk-preloader').hide();
                orders = jqXHR.responseJSON;
                console.log("/api/v1/orders?page[page]=1&page[page-size]=20:", orders);

                // update budge on sidebar
                $('.lk-sidebar .lk-sidebar__menu-link-badge').text(orders.meta.total).css('visibility', 'visible');
                $('.footer-nav .footer-nav__button-badge').text(orders.meta.total);
                $('.acc-info-wrapper .orders-count').text(orders.meta.total);
            }
        });

        $('.acc-info-wrapper .acc-info-frm').on('submit', function (e) {
            e.preventDefault();

            let data = {
                attributes: {
                    email: $('.acc-info-wrapper input[name="email"]').val(),
                    name: $('.acc-info-wrapper input[name="name"]').val(),
                },
                id: $('.lk-sidebar .mai-content .mai-content__title').attr('data-client-id'),
                type: 'clients',
            };

            if ($('.acc-info-wrapper input[name="pass"]').val()) {
                data.attributes.password = $('.acc-info-wrapper input[name="pass"]').val();
            }

            $.ajax({
                url: LK.api_domain + '/api/v1/me',
                method: 'PATCH',
                xhrFields: {
                    withCredentials: true
                },
                headers: {
                    'Authorization': token,
                },
                data:
                    JSON.stringify({
                        data
                    }),
                async: false,
                contentType: 'application/json',
                complete: function (jqXHR, status) {

                    let resMe = jqXHR.responseJSON;
                    console.log("PATCH /api/v1/me", resMe);


                    // update user info
                    $('.lk-sidebar .mai-content .mai-content__title').text(resMe.data.attributes.name).attr('data-client-id', resMe.data.id);
                    $('.lk-sidebar .mai-content .mai-content__email').text(resMe.data.attributes.email);

                    $('.acc-info-wrapper input[name="name"]').val(resMe.data.attributes.name).attr('readonly', true);
                    $('.acc-info-wrapper input[name="email"]').val(resMe.data.attributes.email).attr('readonly', true);
                    $('.acc-info-wrapper input[name="pass"]').attr('readonly', true).attr('placeholder', '********');
                }
            });

        });
    });
};